import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';

const NoMessageBox = ({ onAskClick, isChatActive }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let delayTimer;

    if (!isChatActive && !shouldRender) {
      delayTimer = setTimeout(() => {
        setShouldRender(true);
      }, 400);
    } else if (isChatActive) {
      setShouldRender(false);
    }

    return () => {
      if (delayTimer) clearTimeout(delayTimer);
    };
  }, [isChatActive, shouldRender]);

  return (
    <AnimatePresence>
      {shouldRender && (
        <motion.div
          className="no-message-box"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <span className="no-messages">Немає повідомлень</span>
          <span className="no-messages-subtitle">Тут будуть показані повідомлення від команди</span>
          <button className="ask-button" onClick={onAskClick}>
            Задати питання
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NoMessageBox;
